import PageContentContainer from "../../Container/PageContentContainer";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import ContentBox from "../../ContentBox/ContentBox";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useCase } from "../../../provider/CaseProvider";
import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { HydraCollectionResult } from "../../../types/HydraCollectionResult";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useRegisterRefetchPageData } from "../../../hooks/useRegisterRefetchPageData.ts";
import { ExecutionJob } from "../../../types/ExecutionJob/ExecutionJob.ts";
import ExecutionJobStatusChip from "../../Executionjob/ExecutionJobStatusChip.tsx";

const CaseExecutionJobsPage = () => {
  const { product, isLoading: isCaseLoading, refreshCase } = useCase();
  const queryClient = useQueryClient();

  const caseIri = product?.backofficeCase["@id"];
  const executionJobsFilter = { case: caseIri };

  const { data: executionJobCollection, isLoading: isExecutionJobsLoading } = useQuery<
    HydraCollectionResult<ExecutionJob>
  >({
    queryKey: queryKeys.collection("execution_jobs", executionJobsFilter),
    queryFn: () => fetchCollection("execution_jobs", executionJobsFilter),
    enabled: !!product,
  });

  const reloadPage = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.collection("execution_jobs", executionJobsFilter),
    });
    refreshCase();
  };

  useRegisterRefetchPageData(reloadPage);

  if (isCaseLoading || !product || isExecutionJobsLoading || !executionJobCollection) {
    return <LegalBirdPageLoading />;
  }

  const executionJobs = executionJobCollection["hydra:member"];

  return (
    <PageContentContainer>
      <ProductHeadline title="Execution Jobs von" product={product} />
      <ContentBox>
        {executionJobs.length === 0 && (
          <Typography>Für diesen Fall sind noch keine Execution Jobs vorhanden.</Typography>
        )}
        {executionJobs.length > 0 && (
          <TableContainer>
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Titel</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Agent</TableCell>
                  <TableCell>Schritte</TableCell>
                  <TableCell>Freigabe nötig</TableCell>
                  <TableCell>Erstellt</TableCell>
                  <TableCell>Aktualisiert</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {executionJobs.map((job) => (
                  <TableRow key={job.id}>
                    <TableCell>
                      <Link to={`${job.id}`}>{job.id}</Link>
                    </TableCell>
                    <TableCell>{job.jobTitle || "-"}</TableCell>
                    <TableCell>
                      <ExecutionJobStatusChip executionJob={job} />
                    </TableCell>
                    <TableCell>{job.agentType || "-"}</TableCell>
                    <TableCell>{job.steps?.length || 0}</TableCell>
                    <TableCell>{job.requiresApproval ? "Ja" : "Nein"}</TableCell>
                    <TableCell>{dayjs(job.created).format("DD.MM.YYYY HH:mm")}</TableCell>
                    <TableCell>{dayjs(job.updated).format("DD.MM.YYYY HH:mm")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </ContentBox>
    </PageContentContainer>
  );
};

export default CaseExecutionJobsPage;
